import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-it-consulting',
  templateUrl: './it-consulting.component.html',
  styleUrls: ['./it-consulting.component.scss']
})
export class ItConsultingComponent implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'IT Consulting, Integration & Modernisation | DotBlack',
      description: 'Improve applications, data, infrastructure and integration with practical IT consulting and implementation support from DotBlack.',
      path: '/it-consulting/',
      type: 'website',
      schema: { '@context': 'https://schema.org', '@type': 'Service', name: 'IT Consulting', provider: { '@type': 'Organization', name: 'DotBlack Projex Pty (Ltd)', url: 'https://dotblack.co.za/' }, url: 'https://dotblack.co.za/it-consulting/' }
    });
  }
}
